import { z } from 'zod';

/**
 * LoginFormSchema
 */

export const LoginFormSchema = z.object({
  login: z.string().nonempty({
    message: "Digite um login válido!",
  }),
  password: z.string().nonempty({
    message: "Digite uma senha válida!",
  }),
});

export type LoginForm = z.infer<typeof LoginFormSchema>;